import { Component, OnInit } from '@angular/core';
import { TranslationService } from '../../../Services/translation.service';

@Component({
  selector: 'app-investors',
  templateUrl: './investors.component.html',
  styleUrls: ['../aboutus/aboutus.component.css','./investors.component.css']
})
export class InvestorsComponent implements OnInit {
  language: String = 'bg';

  constructor(private translationService: TranslationService) { }

  ngOnInit(): void {
    this.language = this.translationService.language;
  }

}
